import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

function TururiRegionale() {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(null);

  // Handle input changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Submit the booking form
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    try {
      const response = await fetch('/api/sendInvite', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ...formData,
          selectedDate: selectedDate.toISOString(),
          subject: "Tururi Regionale Booking",
          receiverEmail: "stamatierobert9@gmail.com", // Replace with your email
        }),
      });
      if (!response.ok) {
        throw new Error('Error sending email');
      }
      setSubmitted(true);
    } catch (err) {
      console.error(err);
      setError('There was an error sending your invitation. Please try again later.');
    }
  };

  // Prepare event details for Google Calendar
  const eventTitle = "Tururi Regionale Booking";
  const eventDetails = `Booking for Tururi Regionale on ${selectedDate.toLocaleDateString()}. Message: ${formData.message}`;
  const startDate = new Date(selectedDate);
  startDate.setHours(10, 0, 0, 0); // 10:00 AM start
  const endDate = new Date(startDate.getTime() + 60 * 60 * 1000); // 1 hour later

  // Format date for calendar link: YYYYMMDDTHHmmssZ
  const formatDate = (date) => date.toISOString().replace(/-|:|\.\d{3}/g, '');

  const fixedAttendee = 'livia.morega@gmail.com'; // Replace if desired
  const googleCalendarLink =
    `https://calendar.google.com/calendar/render?action=TEMPLATE` +
    `&text=${encodeURIComponent(eventTitle)}` +
    `&dates=${formatDate(startDate)}/${formatDate(endDate)}` +
    `&details=${encodeURIComponent(eventDetails)}` +
    `&add=${encodeURIComponent(fixedAttendee)}`;

  return (
    <div style={styles.pageContainer}>
      <h1 style={styles.heading}>Tururi Regionale</h1>
      <p style={styles.subheading}>
        Contact us to book your tour and receive an email invitation with a calendar link.
      </p>

      {submitted ? (
        <p>Thank you for your message! An email has been sent to you with the calendar invite option.</p>
      ) : (
        <>
          <form id="bookingForm" onSubmit={handleSubmit} style={styles.form}>
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              required
              style={styles.input}
            />
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              value={formData.email}
              onChange={handleChange}
              required
              style={styles.input}
            />
            <textarea
              name="message"
              placeholder="Your Message"
              value={formData.message}
              onChange={handleChange}
              required
              style={styles.textarea}
            />

            {error && <p style={styles.error}>{error}</p>}

            <div style={styles.calendarWrapper}>
              <label style={styles.dateLabel}>Select Date:</label>
              <DatePicker
                selected={selectedDate}
                onChange={(date) => setSelectedDate(date)}
                inline
                minDate={new Date()}
              />
            </div>

            {/* Wrap the button in an anchor tag linking to the calendar invite */}
            <div style={styles.buttonContainer}>
              <a
                href={googleCalendarLink}
                target="_blank"
                rel="noopener noreferrer"
                style={styles.calendarLink}
              >
                <button type="submit" form="bookingForm" style={styles.button}>
                  Send Message
                </button>
              </a>
            </div>
          </form>
        </>
      )}

      <div style={styles.calendarContainer}>
        <a
          href={googleCalendarLink}
          target="_blank"
          rel="noopener noreferrer"
          style={styles.calendarLink}
        >
          Add to Google Calendar
        </a>
      </div>
    </div>
  );
}

// Shared styles (same as Tururi Pietonale)
const styles = {
  pageContainer: {
    width: '100%',
    padding: '2rem',
    backgroundColor: '#F4F9F9',
    minHeight: '70vh',
    textAlign: 'center',
  },
  heading: {
    fontFamily: 'Georgia, serif',
    fontSize: '2.5rem',
    color: '#2C3E50',
    marginBottom: '1rem',
  },
  subheading: {
    fontFamily: 'Georgia, serif',
    fontSize: '1.2rem',
    color: '#2C3E50',
    marginBottom: '2rem',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '80%',
    margin: '0 auto',
    gap: '1rem',
  },
  input: {
    width: '80%',
    padding: '0.75rem',
    borderRadius: '4px',
    border: '1px solid #ccc',
    fontSize: '1.1rem',
  },
  textarea: {
    width: '80%',
    padding: '0.75rem',
    borderRadius: '4px',
    border: '1px solid #ccc',
    fontSize: '1.1rem',
    minHeight: '100px',
  },
  buttonContainer: {
    marginTop: '1rem',
    marginBottom: '2rem',
  },
  button: {
    padding: '0.75rem 1.5rem',
    fontSize: '1rem',
    backgroundColor: '#2C3E50',
    color: '#FFF',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
  },
  calendarWrapper: {
    width: '80%',
    marginTop: '1rem',
    marginBottom: '6rem',
    transform: 'scale(1.4)',
    transformOrigin: 'top center',
  },
  dateLabel: {
    fontFamily: 'Georgia, serif',
    fontSize: '1rem',
    color: '#2C3E50',
    marginBottom: '0.5rem',
    display: 'block',
  },
  error: {
    color: 'red',
  },
  calendarContainer: {
    marginTop: '2rem',
  },
  calendarLink: {
    display: 'inline-block',
    padding: '0.5rem 1rem',
    fontSize: '1rem',
    backgroundColor: '#2C3E50',
    color: '#FFF',
    borderRadius: '4px',
    textDecoration: 'none',
    transition: 'background-color 0.3s ease',
  },
};

export default TururiRegionale;
